<ng-container *transloco="let t">
@if (invitation()) {
	<ion-item>
    <ion-card class="invit-card">
      <ion-card-header>
        <ion-card-title>
          <ion-item (click)="createPopover()" (keyup.enter)="createPopover()" button="true" detail="false"
                    class="invit-item">
            <app-avatar
	            slot="start"
	            [src]="invitProfile().imgUrl"
	            [alt]="'user avatar'"
	            [initials]="getInitials(invitProfile().username)"
	            [size]="40"
            ></app-avatar>
            <ion-label class="user-label">
              <h2 class="invit-name">{{ invitProfile().username }}</h2>
            </ion-label>
          </ion-item>
        </ion-card-title>
        <ion-card-subtitle>
          <ion-item>
            <ion-label class="d-flex text-nowrap">
              {{ invitation().createdAt | date }}
            </ion-label>
          </ion-item>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-item>
          <ion-label (click)="createMessagePopover(invitation().message, $event)" class="d-flex">
            <p class="mt-auto mb-auto invit-message">
              <span class="invit-quote">"</span>
	            {{ invitation().message }}
	            <span class="invit-quote">"</span>
              </p><span class="invit-more">+</span>
            </ion-label>
          </ion-item>
        </ion-card-content>
	    @if (received()) {
		    <div class="invit-actions">
            <ion-button fill="clear" (click)="decline()">
              {{t('Refuse')}}
	            <ion-icon class="red-text pe-4" name="close"></ion-icon>
            </ion-button>
            <ion-button fill="clear" (click)="accept()">
              {{t('Accept')}}
	            <ion-icon class="red-text" name="checkmark"></ion-icon>
            </ion-button>
          </div>
	    }
      </ion-card>
    </ion-item>
}

</ng-container>
